// Modules
import React from 'react';


// MATERIAL UI
import AppBar from 'material-ui/AppBar';
import Toolbar from 'material-ui/Toolbar';
import IconButton from 'material-ui/IconButton';
import Typography from 'material-ui/Typography';
import MenuIcon from 'material-ui-icons/Menu';

// Styles
import './style.css';

export default props => (
  <AppBar className="app-bar" position="static">
    <Toolbar>
      <IconButton
        className="menu-icon"
        color="contrast"
        aria-label="open drawer"
        onClick={props.handleDrawerToggle}
      >
        <MenuIcon />
      </IconButton>
      <Typography type="title" color="inherit">
        {props.title}
      </Typography>
    </Toolbar>
  </AppBar>
);



// WEBPACK FOOTER //
// ./src/components/ResponsiveAppBar/index.js